import { render, staticRenderFns } from "./LiveCalendar.vue?vue&type=template&id=051695be&scoped=true&"
import script from "./LiveCalendar.vue?vue&type=script&lang=js&"
export * from "./LiveCalendar.vue?vue&type=script&lang=js&"
import style0 from "./LiveCalendar.vue?vue&type=style&index=0&id=051695be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051695be",
  null
  
)

export default component.exports